import { API_ENDPOINTS } from './api-endpoints.constants';

export class SERVICE_WORKER_GENERAL_SETTINGS {
  static readonly ClientClaimRequestTimeOutMs = 5000;
  static readonly DownloadConcurrencyLimit = 20;
}

export class INTERCEPTED_API_ENDPOINTS {

  static readonly getConfig = [
    `${API_ENDPOINTS.configuration.default}/{{template}}/{{versionNumber}}`,
    `${API_ENDPOINTS.configuration.default}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.maatNcq.getConfigWithEmptyResponse}/{{parentId}}/{{template}}/{{versionNumber}}`
    // Add other items here if needed
  ];

  static readonly getDashboardEntities = [
    API_ENDPOINTS.dashboard.getMaatAuditPlans,
    `${API_ENDPOINTS.dashboard.getMaatJobs}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatJobItems}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatJobItemsByAuditPlan}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatNcqs}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatNcqsByJob}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatNcqsByAuditPlan}/{{parentId}}`,
    `${API_ENDPOINTS.dashboard.getMaatPropertyHistoryByJob}/{{parentId}}`,
    API_ENDPOINTS.dashboard.getInspections
    // Add other items here if needed
  ];

  static readonly getConfigAndResponse = [
    `${API_ENDPOINTS.maatAuditPlan.getConfigAndResponse}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.maatJob.getConfigAndResponse}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.maatJobItem.getConfigAndResponse}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.maatNcq.getConfigAndResponse}/{{parentId}}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.inspection.getConfigAndResponse}/{{template}}/{{versionNumber}}/{{id}}`,
    `${API_ENDPOINTS.inspectionCalendar.getConfigAndResponse}/{{template}}/{{versionNumber}}/{{id}}`
  ];

  static readonly save = [
    API_ENDPOINTS.maatAuditPlan.save,
    API_ENDPOINTS.maatJob.save,
    API_ENDPOINTS.maatNcq.save,
    API_ENDPOINTS.inspection.save
    // Add other items here if needed
  ];

  static readonly documentDownload = [
    `${API_ENDPOINTS.document.download}/{{formIdentifier}}/{{fileGuid}}`
  ];

  static readonly documentUpload = [
    API_ENDPOINTS.document.upload
  ];

  static readonly documentRemove = [
    API_ENDPOINTS.document.flagForRemoval,
    API_ENDPOINTS.document.remove
  ];
};
